import clsx from 'clsx';
import { FC, memo } from 'react';

import styles from './tooltip.module.scss';
import { ITooltipProps } from './types';

import { Paragraph } from '../paragraph';

export const Tooltip: FC<ITooltipProps> = memo(
  ({ text, type, arrowType = 'bottom', className = '', ...rest }) => (
    <div className={clsx(styles.container, className)} {...rest}>
      {typeof text === 'string' ? (
        <Paragraph className={clsx(styles.text, styles[`text__${type}`])}>{text}</Paragraph>
      ) : (
        text
      )}
      <div className={clsx(styles.icon, styles[`icon__${arrowType}`])} />
    </div>
  ),
);
